import { Currency } from '@/core/currency/interfaces';

const MDL: Currency = {
    name: 'Moldovan Leu',
    demonym: 'Moldovan',
    majorSingle: 'Leu',
    majorPlural: 'Lei',
    codeNumeric: '498',
    symbol: 'L',
    symbolNative: 'L',
    minorSingle: 'Ban',
    minorPlural: 'Bani',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'MDL',
    delimiters: {
        thousands: '.',
        decimal: ','
    }
};

export default MDL;
